import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const AreaFormSlice = createSlice({
  name: "AreaFormReducer",
  initialState,
  reducers: {
    setAreaData: (state, action) => {
      state.editData = action.payload;
    },

    resetState: (state) => {
      state.editData = {};
    },
  },
});

export const { setAreaData, resetState } = AreaFormSlice.actions;

export default AreaFormSlice.reducer;
